export function normalizeArticle(article) {
  return {
    ...article,
    readingTime: article.readingTime || article.reading_time,
    datePublished: article.datePublished || article.date_published || article.created_at || article.date,
    dateModified: article.dateModified || article.date_modified || article.updated_at || article.created_at || article.date,
  };
}
